import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'プロフィール',
    titleCn: '个人',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  titleCn: strings.titleCn,
  order: 3,
};
